/**
 * MEDIA CONFIG
 *
 * Configuración centralizada de imágenes de la landing.
 * Cada bloque puede tener 1 o N imágenes. Si hay más de 1, se rotan
 * automáticamente con fade out/in usando el componente <RotatingImage />.
 *
 * Para cambiar una imagen: reemplaza el string en `images`.
 * Para poner una galería rotativa: añade más URLs al array `images`.
 * Para ajustar velocidad: cambia `rotationMs` (por defecto 4500 ms).
 */

const DEFAULT_ROTATION_MS = 4500;

export const MEDIA = {
  hero: {
    main: {
      images: ["https://i.imgur.com/sYNrA01.png"],
      alt: "Dashboard de Kubo Payments",
      rotationMs: DEFAULT_ROTATION_MS,
    },
    floating: {
      images: ["https://i.imgur.com/7VomZUr.png"],
      alt: "Recurrencias en Kubo Payments",
      rotationMs: DEFAULT_ROTATION_MS,
    },
  },
  features: {
    recurring: {
      images: ["https://files.catbox.moe/6izi38.png"],
      alt: "Cobro recurrente en automático",
      rotationMs: DEFAULT_ROTATION_MS,
    },
    retry: {
      images: ["https://files.catbox.moe/fue9a3.png"],
      alt: "Recuperación de pagos fallidos",
      rotationMs: DEFAULT_ROTATION_MS,
    },
    checkout: {
      images: ["https://files.catbox.moe/ltcvkt.png"],
      alt: "Checkout con tu marca",
      rotationMs: DEFAULT_ROTATION_MS,
    },
    acquirers: {
      images: ["https://files.catbox.moe/r2r922.png"],
      alt: "Configuración de adquirentes",
      rotationMs: DEFAULT_ROTATION_MS,
    },
    manual: {
      images: ["https://files.catbox.moe/43uq0y.png"],
      alt: "Clientes y cobros manuales",
      rotationMs: DEFAULT_ROTATION_MS,
    },
    dashboard: {
      images: ["https://files.catbox.moe/kmzb6d.png"],
      alt: "Dashboard accionable",
      rotationMs: DEFAULT_ROTATION_MS,
    },
    products: {
      images: ["https://files.catbox.moe/s4kj0a.png"],
      alt: "Catálogo de productos",
      rotationMs: DEFAULT_ROTATION_MS,
    },
  },
};

export const CLIENT_LOGOS_CONFIG = {
  row1: [
    { name: "AIVD", src: "https://files.catbox.moe/p6jfx4.png" },
    { name: "Armadura Sofia", src: "https://files.catbox.moe/pkalsw.png" },
    { name: "Best Supply", src: "https://files.catbox.moe/dawtkl.jpg" },
    { name: "Cary", src: "https://files.catbox.moe/u6r3a8.jpg" },
    { name: "Créditos Guimanfer", src: "https://files.catbox.moe/60pqc9.png" },
    { name: "Delmar", src: "https://files.catbox.moe/967upw.jfif" },
    { name: "Domingo Auto Import", src: "https://files.catbox.moe/wxxkv4.jpg" },
    { name: "Empresas LR", src: "https://files.catbox.moe/767nly.jpg" },
    { name: "Farmavia", src: "https://files.catbox.moe/xl071i.jpg" },
    { name: "Frank SRL", src: "https://files.catbox.moe/68e1by.jpg" },
    { name: "Indy Plaza", src: "https://files.catbox.moe/un8up8.png" },
    { name: "Kenfra Display", src: "https://files.catbox.moe/59zn6e.png" },
    { name: "Liriano Rivas", src: "https://files.catbox.moe/lkl6xt.jpg" },
    { name: "Ortiz Power", src: "https://files.catbox.moe/p9snp2.jpg" },
    { name: "Príncipe", src: "https://files.catbox.moe/7izokm.jfif" },
    { name: "Radiadores Balbi", src: "https://files.catbox.moe/kriwvb.png" },
    { name: "Soluciones Taqui", src: "https://files.catbox.moe/fyf55m.jpg" },
    { name: "Tencontrol", src: "https://files.catbox.moe/qesuif.jfif" },
    { name: "AMG", src: "https://files.catbox.moe/2vrwew.jfif" },
    { name: "Coopsoleste", src: "https://files.catbox.moe/6oto5g.png" },
    { name: "Genautos", src: "https://files.catbox.moe/5jv0rf.jpg" },
    { name: "Keynigui", src: "https://files.catbox.moe/kzk24z.jpg" },
    { name: "Subasta", src: "https://files.catbox.moe/ee5y9l.jpg" },
  ],
  row2: [
    { name: "Apicasa", src: "https://files.catbox.moe/s9k3kf.jpg" },
    { name: "Baldepeg", src: "https://files.catbox.moe/yh23x7.jpg" },
    { name: "Brayan Comunicaciones", src: "https://files.catbox.moe/9smzys.jpeg" },
    { name: "Comercial Fray", src: "https://files.catbox.moe/z85eat.png" },
    { name: "Durán", src: "https://files.catbox.moe/kgf12s.jfif" },
    { name: "División Móvil", src: "https://files.catbox.moe/4is7a1.png" },
    { name: "Electro Muebles Maimón", src: "https://files.catbox.moe/jsz39t.jpg" },
    { name: "Escuela Santa Rita", src: "https://files.catbox.moe/qyly3v.png" },
    { name: "Fondebi", src: "https://files.catbox.moe/crmmtw.jpg" },
    { name: "Hermanos Gálvez", src: "https://files.catbox.moe/b8x2q9.jpg" },
    { name: "Inversiones Estrella Verde", src: "https://files.catbox.moe/ifap31.png" },
    { name: "Ligero", src: "https://files.catbox.moe/na66rq.jpg" },
    { name: "Montichello", src: "https://files.catbox.moe/kgaibq.png" },
    { name: "Plomelectric", src: "https://files.catbox.moe/xkq497.png" },
    { name: "ROMO", src: "https://files.catbox.moe/9y6d1l.png" },
    { name: "SIGMED", src: "https://files.catbox.moe/0e51va.png" },
    { name: "Surtidora Celina", src: "https://files.catbox.moe/zmuk5h.jpg" },
    { name: "Volcris", src: "https://files.catbox.moe/emv89m.jpg" },
    { name: "SIPC", src: "https://files.catbox.moe/fdu9af.jpg" },
    { name: "Fecooptur", src: "https://files.catbox.moe/2ljtnu.png" },
    { name: "Inmerosa", src: "https://files.catbox.moe/sa1th9.jpg" },
    { name: "Pagadores", src: "https://files.catbox.moe/c37a4j.jpg" },
  ],
};

export const BRAND = {
  logo: "https://files.catbox.moe/bi7x6x.png",
  company: "Kubo Payments",
  product: "Kubo Payments",
  ctaUrl: "https://app.kubopayments.com",
};
